window.AG = window.AG || {};
AG.ui = AG.ui || {};

AG.ui.globalnotice = (function () {
    "use strict";


    var activateGlobalNotice = function () {

        var $globalNotice = document.querySelector(".global-notice");

        if (!$globalNotice) return false;

        var perma = $globalNotice.dataset.noticeperma;
        var expirationInSeconds = $globalNotice.dataset.noticeexpire;

        // 30 days default unless specified via data-noticeexpire
        var expirationDuration = expirationInSeconds ? 1000 * parseInt(expirationInSeconds) : 1000 * 60 * 60 * 24 * 30;

        if ($globalNotice) {

            // permanent? always show on page load
            if (perma === 'true') {
                $globalNotice.classList.add('is-active');

            } else {

                // if notice previously existed
                if (localStorage.getItem("globalnotice_" + $globalNotice.dataset.noticeid)) {

                    var currentTime = new Date().getTime();
                    var acceptedTime = parseInt(localStorage.getItem("globalnotice_" + $globalNotice.dataset.noticeid));

                    if (isNaN(acceptedTime) || acceptedTime == null) {
                        // if timestamp not in expected format, show notice
                        $globalNotice.classList.add('is-active');

                    } else {

                        if ((currentTime - acceptedTime) < expirationDuration) {
                            // within time limit, remove
                            $globalNotice.remove();

                        } else {
                            // over time limit, show again
                            $globalNotice.classList.add('is-active');
                        }

                    }

                    // else new notice
                } else {
                    $globalNotice.classList.add('is-active');
                }

            }

            // on dismiss button click, store choice and remove
            $globalNotice.querySelector('.global-notice__close').addEventListener('click', function () {

                if (perma !== 'true') {
                    // set timestamp when closed
                    localStorage.setItem("globalnotice_" + $globalNotice.dataset.noticeid, new Date().getTime());
                }

                $globalNotice.remove();
            });

        }


    };

    return {
        activateGlobalNotice: activateGlobalNotice
    };

}());
